import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { cn } from '../../../utils';
export function Form({ onSubmit, children, defaultValues, schema, className, errors, mode = 'onBlur', }) {
    const methods = useForm({
        mode,
        defaultValues,
        resolver: zodResolver(schema),
        errors,
    });
    const handleSubmit = methods.handleSubmit((values) => onSubmit(values, methods));
    return (_jsx(FormProvider, { ...methods, children: _jsx("form", { onSubmit: handleSubmit, noValidate: true, className: cn('h-full w-full', className), children: typeof children === 'function' ? children(methods) : children }) }));
}
